import styles from "../../etapa-revisao.module.scss";
import type { CampoProps } from "./types-campo";

/** `revisao/campo` do Figma: rótulo + valor, só leitura. */
export function CampoView({ rotulo, valor, testId, className }: CampoProps) {
  return (
    <div className={[styles.campo, className].filter(Boolean).join(" ")} data-testid={testId}>
      <p className={styles.campoRotulo}>{rotulo}</p>
      <p className={styles.campoValor}>{valor}</p>
    </div>
  );
}
